// extracted by mini-css-extract-plugin
module.exports = {"adstxt_wrapper":"ads-txt_adstxt_wrapper__1YHJp","form_button_wrapper":"ads-txt_form_button_wrapper__17CJT"};